import React from "react";
import PropTypes from "prop-types";
import classNames from "../../../utils/classNames";
import "./index.scss";

export default function MessageActionsButton({
  children,
  className = "",
  title = undefined,
  ariaLabel = undefined,
  onClick = undefined,
}) {
  return (
    <button
      type="button"
      className={classNames("msg-act-btn", className)}
      onClick={onClick}
      // Remove native tooltip to avoid duplication with custom InfoIcon tooltip
      // title is intentionally omitted
      aria-label={ariaLabel || title}
    >
      {children}
    </button>
  );
}

MessageActionsButton.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  title: PropTypes.string,
  ariaLabel: PropTypes.string,
  onClick: PropTypes.func,
};
